import '../invoice.scss';

import { arrayOf, bool, func, number } from 'prop-types';
import React from 'react';
import { Col, ModalBody, ModalHeader, Row } from 'reactstrap';

import createModalToggle from '../../../generic/create-modal-toggle';
import EntityLabel from '../../../generic/EntityLabel';
import RequestedChanges from '../../../invoices/RequestedChanges';
import StatusBadge from '../../../invoices/StatusBadge';
import {
  bookingEntryShape,
  detailedInvoiceShape,
  productShape,
} from '../../../prop-types';
import add from '../../../REST/add';
import { isInvoiceStatusReadOnly } from '../../utils';
import InvoiceForm from '../InvoiceForm';
import {
  transformForPatch,
  transformForRendering,
} from '../transform-invoice-helpers';
import InvoiceModalLink from './InvoiceModalLink';
import UpdateInvoiceStatusButton from './UpdateInvoiceStatusButton';

const WrappedInvoiceForm = add({
  update: ({ id, onUpdate }, changedModel) =>
    onUpdate(id, transformForPatch(changedModel)),
  form: InvoiceForm,
});

class UpdateInvoiceModal extends React.Component {
  constructor(props) {
    super(props);

    this.onSetStatus = this.onSetStatus.bind(this);
  }

  onSetStatus(id, status, message) {
    const { setStatus, toggle } = this.props;
    return setStatus(id, status, message).then(() => {
      toggle();
    });
  }

  render() {
    const {
      id,
      model,
      bookingEntries,
      products,
      onUpdate,
      toggle,
      sendCancelInvoiceEmail,
    } = this.props;

    return (
      <div data-qa-field="invoice-content">
        <ModalHeader toggle={toggle} className="w-100">
          <Row className="align-items-center">
            <Col>
              <h3 className="m-0">
                <EntityLabel id={model.id} resourceType="invoice">
                  Invoice
                </EntityLabel>
                <StatusBadge className="ml-4" status={model.status} />
                <span className="ml-3 font-weight-light">{model.name}</span>
              </h3>
            </Col>
            <Col className="text-right">
              <UpdateInvoiceStatusButton
                invoice={model}
                status={model.status}
                className="btn-sm"
                onUpdateStatus={this.onSetStatus}
                sendCancelInvoiceEmail={sendCancelInvoiceEmail}
                toggle={toggle}
              />
            </Col>
          </Row>
        </ModalHeader>
        <ModalBody>
          <RequestedChanges invoice={model} className="pb-3" />
          <WrappedInvoiceForm
            id={id}
            default={transformForRendering(model)}
            bookingEntries={bookingEntries}
            products={products}
            onUpdate={onUpdate}
            readOnly={isInvoiceStatusReadOnly(model.status)}
          />
        </ModalBody>
      </div>
    );
  }
}

UpdateInvoiceModal.propTypes = {
  id: number.isRequired,
  model: detailedInvoiceShape.isRequired,
  bookingEntries: arrayOf(bookingEntryShape.isRequired),
  products: arrayOf(productShape.isRequired).isRequired,
  onUpdate: func.isRequired,
  setStatus: func.isRequired,
  sendCancelInvoiceEmail: func.isRequired,
  toggle: func.isRequired,
  isEditing: bool, // eslint-disable-line react/no-unused-prop-types
};

UpdateInvoiceModal.defaultProps = { bookingEntries: [], isEditing: true };

export default createModalToggle(
  ({ id, isEditing }) => <InvoiceModalLink id={id} isEditing={isEditing} />,
  UpdateInvoiceModal,
  { color: '', className: 'p-0' },
  { size: 'xl' },
);

export { UpdateInvoiceModal as UpdateInvoiceModalComponent }; // for unit tests
